import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'infra-product_tiles_load_time-view';

/**
 * Emitted when the product tiles are visible, irrespective of hydration.
 */
export function trackInfraProductTilesLoadTimeView(
  name: string,
  rsc2: string,
  timestamp3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { name, rsc2, timestamp3 },
  });
}
